import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footer-business-info" };
import PButton from 'primevue/button';
export default /*@__PURE__*/ _defineComponent({
    __name: 'footer-business-info',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "ABN: 99 143 842 569", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("span", null, "CRICOS Provider Code: 00301J", -1)),
                    _createElementVNode("span", null, [
                        _cache[1] || (_cache[1] = _createTextVNode("TEQSA: ", -1)),
                        _createVNode(_unref(PButton), {
                            as: "a",
                            variant: "link",
                            href: "https://www.teqsa.gov.au/national-register/provider/curtin-university-formerly-curtin-university-technology",
                            "data-link-name": "oasis-footer.business-info.teqsa",
                            rel: "noopener",
                            class: "footer-link"
                        }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createTextVNode(" PRV12158 ", -1)
                                ]))]),
                            _: 1
                        })
                    ])
                ])
            ]));
        };
    }
});
